<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.main_title' | translate"
  [description]="'organizer.edit.title.description' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="title.dirty"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="updateTitle()"
>
  <app-form-input-group
    [label]="'organizer.edit.title.content.title' | translate"
    [tips]="
      'organizer.edit.title.content.label'
        | translate: { maxLength: defaultMaximumCharacters }
    "
    [errors]="title?.touched && title?.errors"
    errorKey="title"
  >
    <app-form-textarea
      #content
      [formControl]="title"
      [placeholder]="'organizer.edit.title.placeholder' | translate"
      [rows]="3"
      [maxLength]="defaultMaximumCharacters"
    ></app-form-textarea>
  </app-form-input-group>

  <app-tips
    #rightColumn
    right-column
    [title]="'organizer.edit.title.tips.title' | translate"
    [tips]="'organizer.edit.title.tips.text' | translate"
    [variant]="variantTips"
    [displayArrowIcon]="false"
  ></app-tips>
</app-organizer-shared-layout-edit-field>
